module.exports = __webpack_public_path__ + "static/media/sf-test-18.d27bf3d9.mp3";